<template>
  <nav>
    <v-app-bar flat dark color="#292961" height="45px;">
      <v-toolbar-title class="text-uppercase font-weight-bold">
        <span>CF4</span>
        <span class="font-weight-light">Generator</span>
      </v-toolbar-title>
      <v-spacer/>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn text v-for="(link, i) in links" :key="i" router :to="link.path">

          {{ link.title }}

        </v-btn>

        <v-divider
          class="mx-8"
          inset
          dark
          vertical
        ></v-divider>
      </v-toolbar-items>

      <div class="text-center">
        <v-menu
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ on }">
            <v-avatar size="32">
              <v-btn
                color="red"
                v-on="on"
              >
                <span class="white--text">GB</span>
              </v-btn>

            </v-avatar>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John">
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{user.first_name}}</v-list-item-title>
                  <v-list-item-subtitle>E-claims processor</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    icon
                  >
                    <v-icon>mdi-heart</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>


            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn text @click="menu = false">Cancel</v-btn>
              <v-btn color="primary" text @click="logout()">Logout</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>


    </v-app-bar>

  </nav>
</template>

<script>
    import Links from './navigation';

    export default {
        name: "Navbar",
        fav: null,
        data() {
            return {
                menu: null,
                links: Links,
                user: []
            }
        },

        created: function () {
            this.getUser();
        },

        methods: {
            getUser() {
                this.axios.post('getUser', {}, {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    this.user = response.data.user;
                }).catch((error) => {

                }).finally(() => {
                    // always executed
                });
            },

            logout() {
                this.$snotify.error('Are you sure you want to Log out?', 'Confirm', {
                    timeout: 5000,
                    showProgressBar: true,
                    closeOnClick: false,
                    pauseOnHover: true,
                    buttons: [
                        {
                            text: 'Yes', action: (toast) => {
                                localStorage.clear();
                                location.reload();
                            },
                            bold: false
                        },
                        {text: 'Close', action: (toast) => this.$snotify.remove(toast.id), bold: true},
                    ],
                });
            }
        }
    }
</script>

<style>

</style>
